import { render, staticRenderFns } from "./InformacoesGeraisCCS.vue?vue&type=template&id=401afaac&scoped=true"
import script from "./InformacoesGeraisCCS.vue?vue&type=script&lang=js"
export * from "./InformacoesGeraisCCS.vue?vue&type=script&lang=js"
import style0 from "./InformacoesGeraisCCS.vue?vue&type=style&index=0&id=401afaac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401afaac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
